/**
 * UK Colemak (Colemak letter arrangement on a UK ISO board, Windows KBDUK punctuation / CLDR
 * `en-GB-t-k0-windows` + colemak.org spec): maps a physical code to the unshifted character that
 * key emits. Letters follow Colemak; the punctuation block matches UK QWERTY (the "#/~" key on
 * code Backslash, the extra ISO "\\|" key outside the US-Qwerty code block). Letters uppercase by
 * table convention.
 */
export const UK_COLEMAK_CODE_TO_CHAR: Record<string, string> = {
  Backquote: "`",
  Digit1: "1",
  Digit2: "2",
  Digit3: "3",
  Digit4: "4",
  Digit5: "5",
  Digit6: "6",
  Digit7: "7",
  Digit8: "8",
  Digit9: "9",
  Digit0: "0",
  Minus: "-",
  Equal: "=",
  KeyQ: "Q",
  KeyW: "W",
  KeyE: "F",
  KeyR: "P",
  KeyT: "G",
  KeyY: "J",
  KeyU: "L",
  KeyI: "U",
  KeyO: "Y",
  KeyP: ";",
  BracketLeft: "[",
  BracketRight: "]",
  Backslash: "#", // UK ISO "#/~" key (code Backslash)
  KeyA: "A",
  KeyS: "R",
  KeyD: "S",
  KeyF: "T",
  KeyG: "D",
  KeyH: "H",
  KeyJ: "N",
  KeyK: "E",
  KeyL: "I",
  Semicolon: "O",
  Quote: "'",
  KeyZ: "Z",
  KeyX: "X",
  KeyC: "C",
  KeyV: "V",
  KeyB: "B",
  KeyN: "K",
  KeyM: "M",
  Comma: ",",
  Period: ".",
  Slash: "/",
};

/**
 * The .SC2Hotkeys serialization token per code where UK Colemak's token diverges from charToken of
 * its character. Same UK-ISO divergences as UK QWERTY: the "'/@" key (VK_OEM_3)
 * serializes as "Grave", the "`/not" key (VK_OEM_8) as "OEM8", and TheCore remaps any US backslash
 * binding to Enter on the ISO board. Colemak only rearranges letters (and ";" to code KeyP, "O" to
 * Semicolon), which serialize via the char path, so the token table is identical to UK QWERTY's.
 * Recovered from TheCore's real UK Colemak files (both hands) and verified command-for-command.
 */
export const UK_COLEMAK_CODE_TO_TOKEN: Record<string, string> = {
  Backquote: "OEM8", // "`/not" key, VK_OEM_8
  Quote: "Grave", // "'/@" key, VK_OEM_3
  Backslash: "Enter", // ISO: US backslash bindings remap to Enter
};
